import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateCenteredTextBlockB(section, textLines, hr, widget, buttons) {

  // Inidividual tweens
  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated hr 
  let hrTween = hr ? gsap.to(hr, {
    width: "100%",
    duration: 0.4,
    opacity: 1
  }) : null;

  // Search widget
  let widgetTween = hr ? gsap.to(widget, {
    duration: 0.8,
    y: 0,
    opacity: 1,
  }) : null;

  // Buttons div
  let buttonsTween = buttons ? gsap.to(buttons, {
    x: 0,
    opacity: 1,
    duration: 0.25,
  }) : null;


  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl 
    .addLabel("textStart")
    .add(textLinesTween, "textStart-=0.4")
    .add(hrTween, "textStart")
    .add(widgetTween, "textStart+=0.4")
    .add(buttonsTween);
}